import script from "./AdminDealsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminDealsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminDealsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__